import { render, staticRenderFns } from "./BbeeProductosServiciosMD.vue?vue&type=template&id=5719adc7"
import script from "./BbeeProductosServiciosMD.vue?vue&type=script&lang=js"
export * from "./BbeeProductosServiciosMD.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports